///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NodeTypeEnum, SectorPolarityEnum } from '../../../generated/shared-types.model';

export class TopologyLinkFeatureDTO {
    n0: number;
    n1: number;
    c: string;
    si: number;
    sai: number;
    sd: number;
    sid: number;
    sap: number;
    f: number[];
    tx: number;
    rx: number;
    pr0: number;
    pr1: number;
    a0: number;
    a1: number;
    t: TopologyLinkTypeEnum;
    an0: string;
    an1: string;
    ip0: string;
    ip1: string;
    sp: SectorPolarityEnum;
}

export enum TopologyLinkFeatureFlagsIndexes {
    TO_REMOVE,
    IS_ACTIVE,
    IS_INSTALLED,
    IS_USER_FORCED,
    IS_DISABLED,
    IS_FREQUENCY_FORCED
}

export enum TopologyLinkTypeEnum {
    NOT_CONFIRMED_LOS,
    CONFIRMED_LOS,
    NO_LOS,
    LINK,
    FIBER
}

export interface TopologyNodeFeatureDTO {
    i: number;
    n: string;
    la: number;
    lo: number;
    h: number;
    al?: number;
    mh?: NodeTypeEnum;
    li?: number;
    da?: number;
    dp?: SectorPolarityEnum;
    rm?: number;
    p?: number;
    en?: number;
    bl?: number;
    bmp?: number;
}
